import _implicitStylesheets from "./image.css";
import _implicitScopedStylesheets from "./image.scoped.css?scoped=true";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<div${"c0"}${2}><img${"a1:src"}${"a1:alt"}${3}></div>`;
function tmpl($api, $cmp, $slotset, $ctx) {
  const {ncls: api_normalize_class_name, b: api_bind, sp: api_static_part, st: api_static_fragment} = $api;
  const {_m0} = $ctx;
  return [api_static_fragment($fragment1, 1, [api_static_part(0, {
    className: api_normalize_class_name($cmp.classes)
  }, null), api_static_part(1, {
    on: {
      "load": _m0 || ($ctx._m0 = api_bind($cmp.handleLoaded))
    },
    attrs: {
      "src": $cmp.imgSrc,
      "alt": $cmp.alt
    }
  }, null)])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-7h4tg1fa3gk";
tmpl.legacyStylesheetToken = "undefined-_image";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
